/** Unknown/new positions remain visible at the end; stale saved IDs are harmless. */
export function orderQuotePositions<T extends { id: string }>(positions: T[], order: readonly string[]): T[] {
  const ranks = new Map(order.map((id, index) => [id, index]));
  return [...positions].sort((a, b) => (ranks.get(a.id) ?? order.length) - (ranks.get(b.id) ?? order.length));
}

export function moveQuotePosition(ids: string[], source: string, target: string): string[] {
  const from = ids.indexOf(source), to = ids.indexOf(target);
  if (from < 0 || to < 0 || from === to) return ids;
  const next = [...ids];
  next.splice(from, 1);
  next.splice(to, 0, source);
  return next;
}
